import PageHeaderWrapper from './page-header-wrapper';

export default PageHeaderWrapper;
